<template style="padding-top: 10px;">
   <div style="padding-bottom:10px;">
      <v-text-field
         v-if="data.Type === 'string'"
         :label="getTranslation(data.Name, locale)"
         v-model="value"
         outlined
         hide-details
         style="margin-bottom: 10px;"
      />
      <v-select
         v-else-if="data.Type === 'boolean'"
         v-model="value"
         :items="booleanItems"
         :label="getTranslation(data.Name, locale)"
         item-text="sName"
         item-value="id"
         outlined
         hide-details
         style="margin-bottom: 10px;"
      />
      <v-select
         v-else-if="data.Type === 'language'"
         v-model="value"
         :items="languagesItems"
         :label="getTranslation(data.Name, locale)"
         item-text="sName"
         item-value="id"
         outlined
         hide-details
         style="margin-bottom: 10px;"
      />
      <v-layout 
         v-else-if="data.Type === 'date'"
         wrap
      >
         <v-flex xs12 style="padding-right: 0;">
          <attendance-date
            :value="value"
            :label="getTranslation(data.Name, locale)"
            :onChange="handleChangeDate"
            :locale="locale"
          />
         </v-flex>
      </v-layout>
      <v-select
         v-else-if="data.Type === 'select' && selectItems"
         v-model="value"
         :items="selectItems"
         :label="getTranslation(data.Name, locale)"
         item-text="sName"
         item-value="id"
         outlined
         hide-details
         style="margin-bottom: 10px;"
      />
      <v-layout 
         v-else-if="data.Type === 'phone'"
         wrap
      >
         <v-flex xs4 style="padding-right: 10px;">
            <v-text-field
               :label="getTranslation({ es: 'Prefijo', en: 'Country code', de:'Vorwahl', fr: 'Indicatif' }, locale)"
               v-model="pref"
               @input="handleChangePhone"
               outlined
               hide-details
               style="margin-bottom: 10px;"
            />
         </v-flex>
         <v-flex xs8 style="padding-left: 10px;">
            <v-text-field
               :label="getTranslation({ es: 'Teléfono', en: 'Telephone', de: 'Telefonnummer', fr: 'Téléphone' }, locale)"
               v-model="phone"
               @input="handleChangePhone"
               outlined
               hide-details
               style="margin-bottom: 10px;"
            />
         </v-flex>
      </v-layout>
      <v-layout 
         wrap
         v-else-if="data.Type === 'terms'" 
      >
         <v-flex xs1 style="text-align: right;">
            <v-checkbox 
               v-model="value" 
               hide-details
               style="margin:0;padding:0"
               @change="handleChangeCheckTerms"
            />
         </v-flex>
         <v-flex xs11>
            <terms-view 
               terms="aaaa"
               :locale="locale"
               :onOK="handleChangeTerms"
               :btnTerms="data.Name"
              :termsData="data.TermsData"
            />
         </v-flex>
      </v-layout>
      <div v-else>
      {{data}}
      </div>
      <small v-if="showError && data.Required && !data.value" style="color: red;">{{ $t('common.required', locale) }}</small>
   </div>
</template>
<script>
import utils from '@/services/utils'
import TermsView from './TermsView'
import AttendanceDate from './AttendanceDate'
export default {
   components: {
      TermsView,
    AttendanceDate,
   },
   props: {
      data: {
         type: Object,
         required: true,
      },
      locale: {
         type: String,
         required: true,
      },
      languages: {
         type: String,
         required: true,
      },
      onChange: {
         type: Function,
         required: true,
      },
      showError: {
         type: Boolean,
         required: true,
      },
   },
   data: () => ({
      value: null,
      pref: null,
      phone: null,
      selectItems: null,
      booleanItems: [
         {
            id: true,
            sName: 'SI',
            name: { es: 'SI', en: 'YES', de: 'JA' }
         },
         {
            id: false,
            sName: 'NO',
            name: { es: 'NO', en: 'NO', de: 'NEIN' }
         }
      ],
      languagesItems: null,
   }),
   computed: {
      allLanguages () {
        return utils.getAllLanguages(this.languages.split(','))
      },
   },
   watch: {
      locale () {
         this.prepareTranslate()
      },
      value () {
         this.onChange(this.value)
      },
      'data.value' () {
         this.prepareValue()
      },
   },
   mounted () {
      this.prepareValue()
      this.prepareTranslation()
   },
   methods: {
      prepareValue () {
         if (this.data.Type === 'phone') {
            if (this.data.value) {
               const f = this.data.value.split(' ')
               if (f.length > 1) {
                  this.phone = f.pop()
                  this.pref = f.pop().replace('(', '').replace(')', '')
               }
            }
         } else this.value = this.data.value
      },
      prepareTranslation () {
         if (this.data.Type === 'select') {
            const aux = this.data.Values ? JSON.parse(this.data.Values) : null
            if (aux) {
               this.selectItems = aux.map(item => {
                  return {
                     id: item.id,
                     name: item.name,
                     sName: utils.getTranslation(item.name, this.locale)
                  }
               })
            }
         }
         this.languagesItems = this.allLanguages.map(item => {
            return {
               id: item.ID,
               name: { es: item.Name },
               sName: item.Name
            }
         })
         this.booleanItems = this.booleanItems.map(item => {
            item.sName = utils.getTranslation(item.name, this.locale)
            return item
         })
      },
      getTranslation (v, locale) {
         return utils.getTranslation(v, locale).concat(this.data.Required ? ' (*) ' : '')
      },
      handleChangeDate (v) {
        this.value = v
      },
      handleChangePhone () {
         if (!this.pref || this.pref.length === 0 || !this.phone || this.phone.length === 0) {
            this.value = null
            return null
         }
         const aux = `(${this.pref}) ${this.phone}`
         this.value = aux
      },
      handleChangeTerms () {
         this.value = true
      },
      handleChangeCheckTerms (){
         if(!this.value) this.value = null
      },
   },
}
</script>

